<template>
  <div class="h-full">
    <vxe-toolbar ref="toolbarRef" custom>
      <template #buttons>
        <el-button
          size="small"
          :type="
            !tableConfig.mainButtonType ? 'primary' : tableConfig.mainButtonType
          "
          v-if="tableConfig.mainButton"
          @click="mainButtonClick"
          >{{ tableConfig.mainButtonTitle || "" }}
        </el-button>
      </template>
      <template #tools>
        <el-button
          v-if="tableConfig.columnOrdering"
          icon="el-icon-s-tools"
          circle
          @click="openModalSetting"
        ></el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      size="mini"
      :loading="loadingTable"
      empty-text="Empty Data"
      keep-source
      border
      :size="tableConfig.size"
      :show-overflow="tableConfig.bodyOverflow"
      class="mt-5"
      auto-resize
      :footer-method="footerMethod"
      show-footer
      :show-header-overflow="tableConfig.headerOverflow"
      :ref="tableConfig.tableName"
      :height="tableConfig.tableHeight"
      row-key
      :merge-cells="mergeCells()"
      highlight-hover-row
      highlight-current-row
      :row-config="{
        isCurrent: true,
        isHover: true,
        height: tableConfig.rowHeight,
      }"
      :column-config="{ resizable: true }"
      :data="tableConfig.tableData"
      :mouse-config="{ selected: true }"
      :sort-config="{ multiple: true, trigger: 'cell' }"
      :checkbox-config="{
        highlight: true,
        range: true,
        visibleMethod: checkoxVisible,
      }"
      :expand-config="{ accordion: true }"
      :row-style="rowStyle"
      :cell-style="cellStyle"
      :header-cell-style="headerCellStyle"
      :keyboard-config="{
        isArrow: true,
        isDel: true,
        isEnter: true,
        isTab: true,
        isEdit: true,
      }"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        showStatus: true,
      }"
      :scroll-y="{ mode: 'wheel' }"
      :custom-config="{ mode: 'popup' }"
      @checkbox-all="selectedCheckbox"
      @checkbox-change="selectedCheckbox"
      @filter-change="changeFilter"
      @scroll="scrollData"
      @resizable-change="resizableChangeEvent"
      @cell-dblclick="dblclickEvent"
    >
      <vxe-column
        type="seq"
        fixed="left"
        :title="!tableConfig.seqTitle ? '#' : tableConfig.seqTitle"
        width="60"
      />
      <vxe-column type="checkbox" width="60" v-if="tableConfig.checkbox" />
      <vxe-column
        :title="tableConfig.selectTitle || 'SELECT'"
        width="150"
        align="center"
        v-if="tableConfig.select"
      >
        <template #default="{ row }">
          <template v-if="!tableConfig.selectButtonTrigger">
            <el-button
              :type="tableConfig.selectType || 'primary'"
              @click="sendData(row)"
              icon="el-icon-check"
              size="mini"
              >{{ tableConfig.selectButton || "Select" }}</el-button
            >
          </template>

          <template v-if="tableConfig.selectButtonTrigger">
            <el-button
              v-if="!row[tableConfig.selectButtonTrigger]"
              :type="tableConfig.selectType || 'primary'"
              @click="sendData(row)"
              icon="el-icon-check"
              size="mini"
              >{{ tableConfig.selectButton || "Select" }}</el-button
            >

            <el-button
              v-if="row[tableConfig.selectButtonTrigger]"
              :type="tableConfig.selectTypeChange || 'primary'"
              @click="sendData(row)"
              icon="el-icon-check"
              size="mini"
              >{{ tableConfig.selectButtonChange || "Select" }}</el-button
            >
          </template>
        </template>
      </vxe-column>
      <vxe-column
        :title="tableConfig.selectTitle2 || 'SELECT'"
        width="120"
        align="center"
        v-if="tableConfig.select2"
      >
        <template #default="{ row }">
          <template v-if="!tableConfig.selectButtonTrigger2">
            <el-button
              :type="tableConfig.selectType2 || 'primary'"
              @click="sendData2(row)"
              icon="el-icon-check"
              size="mini"
              >{{ tableConfig.selectButton2 || "Select" }}</el-button
            >
          </template>

          <template v-if="tableConfig.selectButtonTrigger2">
            <el-button
              v-if="!row[tableConfig.selectButtonTrigger2]"
              :type="tableConfig.selectType2 || 'primary'"
              @click="sendData2(row)"
              icon="el-icon-check"
              size="mini"
              >{{ tableConfig.selectButton2 || "Select" }}</el-button
            >

            <el-button
              v-if="row[tableConfig.selectButtonTrigger2]"
              :type="tableConfig.selectTypeChange2 || 'primary'"
              @click="sendData2(row)"
              icon="el-icon-check"
              size="mini"
              >{{ tableConfig.selectButtonChange2 || "Select" }}</el-button
            >
          </template>
        </template>
      </vxe-column>

      <template v-for="(d, index) in tableConfig.column">
        <template v-if="!d.children">
          <vxe-column
            :fixed="d.fixed"
            sortable
            v-if="!d.edit"
            :key="index"
            :width="d.width"
            :field="d.field"
            header-align="center"
            :align="d.align"
            :title="d.title.toUpperCase()"
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            :formatter="
              d.format == 'number'
                ? $$formatNumber
                : d.format == 'price'
                ? $$formatAmountBc
                : d.format == 'date'
                ? $$formatDate
                : d.format == 'datetime'
                ? $$formatDatetimemoment
                : d.format == 'time'
                ? $$formatHHMM
                : ''
            "
          >
            <template #filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                style="padding: 5px"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>

          <vxe-column
            sortable
            v-else
            :fixed="d.fixed"
            :width="d.width"
            :field="d.field"
            header-align="center"
            :align="d.align"
            :title="d.title"
            :filters="[{ data: '' }]"
            :edit-render="{ autofocus: '.vxe-input--inner' }"
            :filter-method="$$filterHeaderTable"
            :formatter="
              d.format == 'number'
                ? $$formatNumber
                : d.format == 'price'
                ? $$formatAmountBc
                : d.format == 'date'
                ? $$formatDate
                : d.format == 'datebc'
                ? $$formatDatemomentInput
                : d.format == 'time'
                ? $$formatHHMM
                : ''
            "
          >
            <template #edit="{ row, column }">
              <vxe-input
                @blur="blurInput({ row, column })"
                @input="inputData({ row, column })"
                v-model="row[d.field]"
                size="mini"
                type="text"
              ></vxe-input>
            </template>
            <template #filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                style="padding: 5px"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
        </template>
        <template v-if="d.children">
          <vxe-colgroup :key="d.field" header-align="center" :title="d.title">
            <template v-for="(ch, chi) in d.children">
              <template v-if="!ch.edit">
                <vxe-column
                  sortable
                  :fixed="d.fixed"
                  :key="chi"
                  :width="ch.width"
                  :field="ch.field"
                  header-align="center"
                  :align="ch.align"
                  :title="ch.title"
                  :filters="[{ data: '' }]"
                  :filter-method="$$filterHeaderTable"
                  :formatter="
                    ch.format == 'number'
                      ? $$formatNumber
                      : ch.format == 'price'
                      ? $$formatAmountBc
                      : ch.format == 'date'
                      ? $$formatDate
                      : ch.format == 'datebc'
                      ? $$formatDatemomentInput
                      : d.format == 'time'
                      ? $$formatHHMM
                      : ''
                  "
                >
                  <template #filter="{ $panel, column }">
                    <input
                      type="type"
                      v-for="(option, index) in column.filters"
                      :key="index"
                      style="padding: 5px"
                      v-model="option.data"
                      @input="
                        $panel.changeOption($event, !!option.data, option)
                      "
                    />
                  </template>
                </vxe-column>
              </template>

              <template v-if="ch.edit">
                <vxe-column
                  sortable
                  :fixed="d.fixed"
                  :width="ch.width"
                  :field="ch.field"
                  header-align="center"
                  :align="ch.align"
                  :title="ch.title"
                  :filters="[{ data: '' }]"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                  :filter-method="$$filterHeaderTable"
                  :formatter="
                    ch.format == 'number'
                      ? $$formatNumber
                      : ch.format == 'price'
                      ? $$formatAmountBc
                      : ch.format == 'date'
                      ? $$formatDate
                      : ch.format == 'datebc'
                      ? $$formatDatemomentInput
                      : d.format == 'time'
                      ? $$formatHHMM
                      : ''
                  "
                >
                  <template #edit="{ row, column }">
                    <vxe-input
                      @blur="blurInput({ row, column })"
                      @input="inputData({ row, column })"
                      v-model="row[ch.field]"
                      size="mini"
                      type="text"
                    ></vxe-input>
                  </template>
                  <template #filter="{ $panel, column }">
                    <input
                      type="type"
                      v-for="(option, index) in column.filters"
                      :key="index"
                      style="padding: 5px"
                      v-model="option.data"
                      @input="
                        $panel.changeOption($event, !!option.data, option)
                      "
                    />
                  </template>
                </vxe-column>
              </template>
            </template>
          </vxe-colgroup>
        </template>
      </template>
      <vxe-column
        sortable
        v-for="d in customCol"
        :filters="[{ data: '' }]"
        :filter-method="$$filterHeaderTable"
        width="150"
        align="center"
        :key="d.key"
        :field="d.key"
        :title="d.title"
        :formatter="
          d.format == 'number'
            ? $$formatNumber
            : d.format == 'price'
            ? $$formatAmountBc
            : d.format == 'date'
            ? $$formatDate
            : d.format == 'datetime'
            ? $$formatDatetimemoment
            : d.format == 'time'
            ? $$formatHHMM
            : ''
        "
      >
      </vxe-column>
    </vxe-table>
    <vxe-modal
      v-model="modalSetting"
      title="Setting"
      width="600"
      height="400"
      v-if="tableConfig.columnOrdering"
      show-zoom
      resize
    >
      <template #default>
        <el-button type="danger" @click="resetSetting">Reset</el-button>
        <draggable
          tag="div"
          :list="tableConfig.column || []"
          class="flex flex-col space-y-1"
          handle="#handle-tablefull"
          @end="handleEnd"
        >
          <div
            v-for="(element, idx) in tableConfig.column || []"
            :key="idx"
            class="flex flex-col"
          >
            <div
              class="flex flex-row items-center bg-white shadow space-x-2 p-2"
            >
              <i class="el-icon-more" id="handle-tablefull"></i>
              <span>{{ element.title || "" }}</span>
            </div>
            <div v-if="element.children" class="flex flex-col ml-2 mt-2">
              <draggable
                tag="div"
                :list="element.children || []"
                @end="handleEnd"
                class="flex flex-col space-y-1"
              >
                <div
                  v-for="(element, idxChildren) in element.children || []"
                  :handle="'#handle-tablefull-' + idx"
                  :key="idxChildren"
                  class="flex flex-row items-center bg-white shadow space-x-2 p-2"
                >
                  <i class="el-icon-more" :id="'#handle-tablefull-' + idx"></i>
                  <span>{{ element.title || "" }}</span>
                </div>
              </draggable>
            </div>
          </div>
        </draggable>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
export default {
  props: [
    "tableConfig",
    "rowStyleFunction",
    "checkoxVisibleFunction",
    "cellStyleFunction",
    "headerStyleFunction",
    "mergeCellFunction",
  ],
  components: {
    Draggable,
  },
  data() {
    return {
      selectTab: "raw",
      loadingTable: false,
      modalBarang: false,
      tableData: [],
      customCol: [],
      columnExpand: [],
      modalSetting: false,
      oldCol: [],
    };
  },

  methods: {
    handleEnd() {
      const keyPath = this.$router.history.current.fullPath;
      // const data = this.tableConfig.column.map((datas) => {
      //   let d = { key: datas.field };
      //   if (datas.children) {
      //     d.children = datas.children.map((c) => ({ key: c.field }));
      //   }
      //   return d;
      // });
      localStorage.setItem(
        "table_order_" + keyPath,
        JSON.stringify(this.tableConfig.column)
      );
      return true;
    },
    openModalSetting() {
      this.modalSetting = true;
    },
    mergeCells() {
      if (this.mergeCellFunction) {
        return this.mergeCellFunction();
      }
      return [];
    },
    headerCellStyle({ column }) {
      if (this.headerStyleFunction) {
        return this.headerStyleFunction(column);
      }
    },
    getColumns() {
      const columns = this.$refs[this.tableConfig.tableName].getColumns();
      return columns;
    },
    updateFooter() {
      this.$refs[this.tableConfig.tableName].updateFooter();
    },
    resizableChangeEvent() {
      const columns = this.$refs[this.tableConfig.tableName].getColumns();
      const customData = columns.map((column) => {
        return {
          width: column.renderWidth,
        };
      });
    },
    cellStyle({ row, column }) {
      if (this.cellStyleFunction) {
        return this.cellStyleFunction(row, column);
      }
      return {};
    },
    checkoxVisible({ row }) {
      if (this.checkoxVisibleFunction) {
        return this.checkoxVisibleFunction(row);
      }
      return true;
    },
    scrollData(scroll) {
      // if (scroll.isY) {
      // }
    },
    toggleLoading() {
      if (this.loadingTable) {
        this.loadingTable = false;
      } else {
        this.loadingTable = true;
      }
    },
    inputData(props) {
      this.$emit("inputEdit", props);
    },
    blurInput(props) {
      this.$emit("blurEdit", props);
    },
    dblclickEvent(props) {
      this.$emit("dblClick", props);
    },
    footerMethod({ columns, data }) {
      let dataFooter = !this.tableConfig.dataFooter
        ? []
        : this.tableConfig.dataFooter;
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return dataFooter.length > 0 ? "TOTAL" : "";
          }

          if ([...dataFooter].includes(column.property)) {
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    reloadData() {
      this.$refs[this.tableConfig.tableName].reloadData(
        this.tableConfig.tableData
      );
    },
    changedData(data) {
      this.$refs[this.tableConfig.tableName].reloadData(data);
    },

    changeFilter(data) {
      this.$emit("changeFilter", data);
    },
    rowStyle({ row }) {
      if (this.rowStyleFunction) {
        return this.rowStyleFunction(row);
      }
    },
    refreshColumn() {
      this.$refs[this.tableConfig.tableName].refreshColumn();
    },
    selectedCheckbox() {
      let data = this.$refs[this.tableConfig.tableName].getCheckboxRecords();
      this.$emit("selectedData", data);
      return data;
    },
    async getBarang(jenis) {
      console.log(jenis);
    },
    sendData(row) {
      this.$emit("sendData", row);
    },
    sendData2(row) {
      this.$emit("sendData2", row);
    },
    susunColumn(dataAwal, col) {
      let data = [];
      col.forEach((c) => {
        const find = dataAwal.find((f) => f.field === c.key);
        if (find) {
          let d = find;
          // if (c.children) {
          //    = c.children.map(v=>{
          //     return
          //   })
          //   d.children
          // }
          data.push(d);
        }
      });
      return data;
    },
    // susunData(dataAwal, order) {
    //   // Buat objek Map untuk menyimpan indeks field
    //   const fieldIndexMap = new Map();
    //   dataAwal.forEach((item, index) => {
    //     fieldIndexMap.set(item.field, index);
    //   });

    //   let dataHasil = [];

    //   order.forEach((item) => {
    //     const index = fieldIndexMap.get(item.field);
    //     if (index !== undefined) {
    //       dataHasil.push(dataAwal[index]);
    //       if (item.children) {
    //         dataHasil[dataHasil.length - 1].children = susunData(
    //           dataAwal[index].children,
    //           item.children
    //         );
    //       }
    //     }
    //   });
    //   console.log(dataHasil, dataAwal, order, "sjkdnasjkdaskdba");
    //   return dataHasil;
    // },
    // reorderCols(colOrder, col) {
    //   let result = [];
    //   let cols = col;
    //   let colOrders = colOrder;
    //   // const susunCol = (cols)=> {
    //   //   let data =
    //   // for (let i = 0; i < col.length; i++) {

    //   // }
    //   // }
    //   for (let i = 0; i < col.length; i++) {
    //     if (!colOrder[i]) {
    //       result.push(...cols);
    //       break;
    //     }
    //     let d = cols.findIndex((f) => f.field === colOrder[i].key);
    //     // if (d.children) {
    //     //   for (let indexChil = 0; indexChil < d.children.length; indexChil++) {
    //     //     // const element = array[indexChil];
    //     //   }
    //     // }
    //     if (d !== -1) {
    //       result.push(cols[d]);
    //       cols = cols.filter((f, j) => f.field !== colOrder[i].key);
    //     }
    //   }
    //   return result;
    // },
    resetSetting() {
      this.tableConfig.column = this.oldCol;
      const keyPath = this.$router.history.current.fullPath;
      localStorage.removeItem("table_order_" + keyPath);
    },
  },
  created() {
    if (!this.tableConfig.tableName) {
      this.tableConfig.tableName = "xTable";
    }
  },
  mounted() {
    if (!this.tableConfig.tableHeight) {
      this.tableConfig.tableHeight = null;
    }

    if (this.tableConfig.bodyOverflow == null) {
      this.tableConfig.bodyOverflow = true;
    }

    if (this.tableConfig.headerOverflow == null) {
      this.tableConfig.headerOverflow = true;
    }
    if (!this.tableConfig.size) {
      this.tableConfig.size = "small";
    }
    if (!this.tableConfig.rowHeight) {
      this.tableConfig.rowHeight = 35;
    }
    if (this.tableConfig.customHead) {
      const customHead = this.$store.state.customHead;
      let customCols = [];
      for (const key in customHead) {
        if (customHead[key] && customHead[key] != "") {
          let type; // type
          if (key.search("date") !== -1) {
            type = "date";
          } else if (key.search("number") !== -1) {
            type = "price";
          } else {
            type = "";
          }
          customCols.push({
            key: key,
            title: customHead[key],
            format: type,
          });
        }
      }
      this.customCol = customCols;
    }
    if (!this.tableConfig.column) {
      this.tableConfig.column = [];
    } else {
      let cols = [];
      cols = this.tableConfig.column.filter((f) => f.show != false);
      this.tableConfig.column = cols;

      this.$refs[this.tableConfig.tableName].loadColumn(cols);

      setTimeout(() => {
        this.$refs[this.tableConfig.tableName].refreshColumn();
      }, 1500);
    }

    if (!this.tableConfig.tableData) {
      this.tableConfig.tableData = [];
    }
    if (!this.tableConfig.checkbox) {
      this.tableConfig.checkbox = false;
    }
    if (!this.tableConfig.select) {
      this.tableConfig.select = false;
    }
    this.$nextTick(() => {
      this.$refs[this.tableConfig.tableName].connect(this.$refs.toolbarRef);
    });
    const keyPath = this.$router.history.current.fullPath;
    let colOrder = localStorage.getItem("table_order_" + keyPath);
    if (colOrder) {
      colOrder = JSON.parse(colOrder);
      // //   // this.tableConfig.column = this.reorderCols(
      // //   //   colOrder,
      // //   //   this.tableConfig.column
      // //   // );
      this.oldCol = this.tableConfig.column;
      this.tableConfig.column = this.susunColumn(
        this.tableConfig.column,
        colOrder
      );
      // // this.tableConfig.column = colOrder.map(cols=> {
      // //   let d = this.tableConfig.column.find(f=> f.field)
      // // })
    }
  },
};
</script>
<style></style>
